import { useCallback } from 'react';
import { FormikHelpers } from 'formik';
import { useAppContext } from 'QuoteApp/services/providers';
import { buildCoveragesByFieldValue } from 'QuoteApp/utils';
import { env } from 'Shared/constants/env';
import { getHealedCoverages } from './utils';
import {
  GetDetailsResponseType,
  transformCoverages,
} from 'QuoteApp/services/endpoints/GetDetails';

type TransformedCoverages = ReturnType<typeof transformCoverages>;

type CoveragesFormData = {
  coverages: any;
};

export const useSaveCoverages = () => {
  const { api, details, setDetails, refreshRate } = useAppContext();

  return useCallback(
    async (
      data: CoveragesFormData,
      actions: FormikHelpers<CoveragesFormData>
    ) => {
      const { updateCoveragesWithoutHealing } = env;

      try {
        const response = await api.saveCoverages({ data }, undefined, {
          updateViaApplication: updateCoveragesWithoutHealing,
          productType: details.productType,
        });
        const updatedDetails = updateCoveragesWithoutHealing
          ? (response.data as GetDetailsResponseType)
          : {
              ...details,
              coverages: response.data as TransformedCoverages,
            };

        actions.setValues({
          coverages: buildCoveragesByFieldValue(
            updatedDetails?.coverages,
            'value'
          ),
        });
        actions.setStatus({
          coverages: getHealedCoverages(updatedDetails?.coverages),
        });
        setDetails(updatedDetails);
        refreshRate();
      } catch (error) {
        // Error already handled elsewhere
      } finally {
        actions.setSubmitting(false);
      }
    },
    [api, details, setDetails, refreshRate]
  );
};
